export default function ProgressBar({ value = 0, className = '' }) {
    const clampedValue = Math.min(100, Math.max(0, value));

    return (
        <div className={`w-full bg-gray-200 rounded-full h-2.5 ${className}`}>
            <div
                className="bg-blue-600 h-2.5 rounded-full transition-all duration-300"
                style={{ width: `${clampedValue}%` }}
            />
        </div>
    );
}
